var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header',{staticClass:"d-lg-block d-none"}),_c('HeaderBack',{staticClass:"d-lg-none d-block"}),_c('CategoryList'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }